import { Img } from '@chakra-ui/react';
import hat from '@texas/assets/transparent_hat.gif';
import { fadeInScaleAnimation } from '@texas/resources/animations/animations';

export function Hat() {
  return <Img animation={fadeInScaleAnimation(400)} src={hat} />;
}
